import { render, staticRenderFns } from "./SetRatesDialog.vue?vue&type=template&id=75cca96e&scoped=true"
import script from "./SetRatesDialog.vue?vue&type=script&lang=js"
export * from "./SetRatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cca96e",
  null
  
)

export default component.exports